import { isTimeSignature } from '@ezchops/musicsheet';
import { isVisibility } from '../common';
import { isTrackInSet } from './TrackInSet';
export function isTrackSet(x) {
    return x != null && typeof x.id == 'string' &&
        (typeof x.ownerId == 'string') &&
        isTimeSignature(x.signature) &&
        (typeof x.leadIn == 'number') &&
        (typeof x.leadOut == 'number') &&
        (typeof x.hasMetronome == 'boolean') &&
        (Array.isArray(x.tracks) && x.tracks.every(isTrackInSet)) &&
        isVisibility(x.visibility) &&
        (typeof x.deleted == 'boolean');
}
//# sourceMappingURL=TrackSet.js.map